import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "./ui/card";
import { CloudAlert } from 'lucide-react'
import { cx } from "class-variance-authority";

const defaultTitle = <>Error</>;
const defaultDescription = "Something went wrong.";

interface ErrorCardProps {
  title?: React.ReactNode;
  description?: string;
  children: React.ReactNode;
  className?: string
}

export function ErrorCard({
  title = defaultTitle,
  description = defaultDescription,
  children,
  className,
}: ErrorCardProps) {
  return (
    <Card className={cx("min-w-[381px] shadow-lg border-opacity-50 backdrop-blur-sm", className)}>
      <CardHeader className="pb-4">
        <CardTitle className="text-2xl font-bold text-foreground flex justify-between relative">
          <div>{title}</div><CloudAlert size={48} className="absolute right-0 top-[50%] -translate-y-[50%] text-destructive" />
        </CardTitle>
        <CardDescription className="text-sm text-muted-foreground/70">
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col">{children}</CardContent>
    </Card>
  );
}
